import {addressTypes} from '../address/AddressConstant'

export const formLayout = {
    group: 'group',
    inline: 'inline',
    grid: 'grid',
    flex: 'flex',
}

export const component = {
    inputText: 'inputText',
    inputNumber: 'inputNumber',
    inputMask: 'inputMask',
    inputTextArea: 'inputTextArea',
    password: 'password',
    phoneInput: 'phoneInput',
    multiCheckbox: 'multiCheckbox',
    checkbox: 'checkbox',
    selectButton: 'selectButton',
    slider: 'slider',
    calendar: 'calendar',
    dropdown: 'dropdown',
    dropdownGroup: 'dropdownGroup',
    fileUpload: 'fileUpload',
    address: 'address',
    multiSelect: 'multiSelect',
    timeZoneSelect: 'timeZoneSelect',
    codeConfiguration: 'codeConfiguration',
    chip: 'chip',
    generalPractitioner: 'generalPractitioner',
    checkBoxGroup: 'checkBoxGroup',
    toggleButton: 'toggleButton',
    radioButton: 'radioButton',

    hospitalOptions: 'hospitalOptions',
    roleOptions: 'roleOptions',
    hcpOptions: 'hcpOptions',
    patientOptions: 'patientOptions',
    pathway: 'pathway',
    notifyMethodTypeOptions: 'notifyMethodTypeOptions',
    // pathwayOptions: 'pathwayOptions',
}

export const classnameTypes = {
    col1: 'col-1',
    col2: 'col-2',
    col3: 'col-3',
    col4: 'col-4',
    col5: 'col-5',
    col6: 'col-6',
    col7: 'col-7',
    col8: 'col-8',
    col9: 'col-9',
    col10: 'col-10',
    col11: 'col-11',
    col12: 'col-12',
    grid: 'grid',
}

export function getComposedDataList(
    refList = [],
    data = {},
    isFilterList = false,
) {
    let dataList = [...refList]
    if (!dataList || !Array.isArray(dataList) || dataList.length < 1) {
        return []
    }

    if (!data || Object.keys(data).length < 1) {
        return dataList.map(item => {
            if (item?.children && item.children.length > 0) {
                for (let i = 0; i < item.children.length; i++) {
                    if (
                        item.children[i].component !== component.address ||
                        item.children[i].component !==
                            component.codeConfiguration
                    ) {
                        delete item.children[i].initialValue
                    } else {
                        if (item.children[i].component === component.address) {
                            item.children[i].initialValue = {
                                type: 'unknown',
                            }
                        } else if (
                            item.children[i].component ===
                            component.codeConfiguration
                        ) {
                            item.children[i].initialValue = [
                                {
                                    genderCode: `${i}`,
                                    paddingSize: '000',
                                },
                            ]
                        }
                    }
                }
            }
            return item
        })
    }
    return dataList.map(item => {
        if (item?.children && item.children.length > 0) {
            for (let i = 0; i < item.children.length; i++) {
                if (
                    item.children[i].component !== component.address &&
                    item.children[i].component !==
                        component.codeConfiguration &&
                    !!data[item.children[i].key]
                ) {
                    if (item.children[i].key === 'type') {
                        item.children[i].initialValue = data['typeValue']
                    } else if (item.children[i].key === 'hospitalName') {
                        item.children[i].initialValue = data['hospitalId']
                    } else if (item.children[i].key === 'roleName') {
                        item.children[i].initialValue = data['roleId']
                    } else {
                        item.children[i].initialValue =
                            data[item.children[i].key]
                    }
                } else {
                    if (item.children[i].component === component.address) {
                        item.children[i].initialValue = {
                            addressId: data['addressId']
                                ? data['addressId']
                                : null,
                            type: data['type']
                                ? data['type']
                                : addressTypes.UNKNOWN.value,
                            addressLine1: data['addressLine1'],
                            addressLine2: data['addressLine2'],
                            addressLine3: data['addressLine3'],
                            addressLine4: data['addressLine4'],
                            refCountry: data['refCountry'],
                            refState: data['refState'],
                            state: data['state'],
                            city: data['city'],
                            postalCode: data['postalCode'],
                            phone: data['phone'],
                            addressConfig: data['addressConfig'],
                        }
                    } else if (
                        item.children[i].component ===
                        component.codeConfiguration
                    ) {
                        item.children[i].initialValue = [
                            ...data['userCodeRules'],
                        ]
                    } else if (
                        item.children[i].component === component.fileUpload
                    ) {
                        item.children[i].initialValue = data['logo']
                    } else if (
                        item.children[i].component ===
                        component.generalPractitioner
                    ) {
                        item.children[i].initialValue =
                            data['generalPractitioner']
                    } else {
                        if (item.children[i].key === 'pathway') {
                            item.children[i].initialValue = data['pathwayIds']
                        }

                        if (!!isFilterList && !data[item.children[i].key]) {
                            delete item.children[i].initialValue
                        }
                    }
                }
            }
        }

        return item
    })
}
